import { api } from 'roboflex-thalamus-request-handler'

export async function listarDespesasProjeto(params = {}) {
    const response = await api.get('projeto/despesa/listar', { params })
    return response.data?.data ?? response.data ?? []
}

export async function listarProjetosDespesa() {
    const response = await api.get('projeto/despesa/projetos')
    return response.data?.data ?? response.data ?? []
}

export async function listarCategoriasDespesa() {
    const response = await api.get('projeto/despesa/categorias')
    return response.data?.data ?? response.data ?? []
}

export async function listarMotivacoesDespesa() {
    const response = await api.get('motivacoes/listar')
    return response.data?.data ?? response.data ?? []
}

export async function gravarDespesaProjeto(payload) {
    const response = await api.post('projeto/despesa/gravar', payload)
    return response.data
}

export async function atualizarDespesaProjeto(id, payload) {
    const response = await api.put(`projeto/despesa/atualizar/${id}`, payload)
    return response.data
}

export async function excluirDespesaProjeto(id) {
    const response = await api.delete(`projeto/despesa/excluir/${id}`)
    return response.data
}
